<script>
  import annotationPlugin from 'chartjs-plugin-annotation'
  import 'chartjs-adapter-luxon'
  import GraphEventTooltip from '@/components/base/GraphEventTooltip'
  import { Chart } from 'chart.js'

  export const defaultGraphOptions = {
    animation: { duration: 0 },
    responsiveAnimationDuration: 0,
    hover: { animationDuration: 0 },
    scaleBeginAtZero: true,
    responsive: true,
    maintainAspectRatio: false,
    legend: {
      display: false,
    },
    scales: {
      xAxes: [
        {
          type: 'time',
          distribution: 'linear',
          time: {
            unit: 'minute',
          },
          ticks: {
            major: {
              enabled: true,
            },
            source: 'data',
            autoSkipPadding: 25,
            autoSkip: true,
            fontFamily: 'Degular',
            maxRotation: 0,
            minRotation: 0,
          },
        },
      ],
      yAxes: [
        {
          display: true,
          position: 'left',
          scaleLabel: {
            display: true,
            labelString: 'Noise Risk Score (NRS)',
            fontFamily: 'Degular',
          },
          ticks: {
            fontFamily: 'Degular',
            stepSize: 20,
            min: 0,
            max: 100,
          },
        },
        {
          display: true,
          position: 'right',
          ticks: {
            fontFamily: 'Degular',
            stepSize: 20,
            min: 0,
            max: 100,
          },
        },
      ],
    },
  }

  export default {
    name: 'Graph',
    props: {
      timezone: String,
      height: {
        type: String,
      },
      tooltipPoints: {
        type: Object,
        default: () => ({}),
      },
      chartModel: {
        type: Object,
      },
      chartOptions: {
        type: Object,
      },
      renderKey: Number,
      chartName: String,
      chartType: {
        type: String,
        default: 'property',
      },
    },
    computed: {
      tooltips () {
        return {
          mode: (this.chartType === 'event') ? 'point' : 'index',
          intersect: false,
          enabled: false,
          custom: GraphEventTooltip(this.$refs.canvas, this.tooltipPoints.events, this.tooltipPoints.alerts, this.timezone),
        }
      },
      mergedOptions () {
        return { tooltips: this.tooltips, ...this.chartOptions }
      },
      plugins () {
        return [annotationPlugin]
      },
    },
    watch: {
      renderKey () {
        this.renderChart(this.chartModel, this.mergedOptions)
      },
    },
    created () {
      this.chartOptions.scales.xAxes[0].adapters = { date: { zone: this.timezone } }
    },
    destroyed () {
      if (window[this.chartName]) window[this.chartName].destroy()
    },
    methods: {
      renderChart (data, options) {
        if (window[this.chartName] && window[this.chartName] !== null) window[this.chartName].destroy()
        window[this.chartName] = new Chart(this.$refs.canvas.getContext('2d'), {
          type: 'line',
          data,
          options,
          plugins: this.plugins,
        })
      },
    },
    render: function (createElement) {
      return createElement(
        'div', { style: { position: 'relative', height: this.height, width: '100%' } },
        [
          createElement(
            'canvas', {
              attrs: {
                id: 1,
              },
              ref: 'canvas',
            },
          ),
        ],
      )
    },
  }
</script>

<style lang="scss">
  .chartjs-custom-tooltip {
    color: white;
    font-family: 'Degular', sans-serif;
    background-color: #694361;
    border-radius: 6px;
    width: 246px;
    height: 130px;
    position: relative;
    box-shadow: 0 10px 16px rgba(0, 0, 0, 0.2);
  }
  .chartjs-custom-tooltip-header {
    height: 28px;
    width: 207px;
    top: 17px;
    left: 13px;
    position: relative;
  }
  .chartjs-custom-tooltip-header__icon {
    position: absolute;
    background: #865c79;
    height: 39px;
    width: 39px;
    border-radius: 50px;
    color: white;
    top: -5px;
    left: -23px;
    box-shadow: 0 3px 5px rgba(0, 0, 0, 0.5);
    display: flex;
    & > .v-icon {
      margin: auto;
    }
  }
  .chartjs-custom-tooltip-header__text {
    background-color: #865c79;
    letter-spacing: 1px;
    text-align: left;
    color: white;
    padding: 2px 26px;
    font-weight: 600;
    width: 207px;
    height: 29px;
    border-radius: 3px;
    font-size: 16px;
    text-transform: uppercase;
  }
  .chartjs-custom-tooltip-body {
    position: absolute;
    min-width: 188px;
    max-width: calc(100% - 35px);
    top: 52px;
    left: 31px;
  }
  .chartjs-custom-tooltip-body__date {
    font-weight: 600;
    font-size: 16px;
    letter-spacing: 1px;
    color: #FFFFFF;
    text-transform: uppercase;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .chartjs-custom-tooltip-body__details {
    font-weight: 600;
    font-size: 16px;
    letter-spacing: 1px;
    line-height: 20px;
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .chartjs-alert-tooltip {
    color: white;
    font-family: 'Degular', sans-serif;
    background-color:rgba(60, 51, 51, 0.8);
    border-radius: 6px;
    width: 128px;
    height: 69px;
    position: relative;
    padding: 10px 16px;
    box-shadow: 0 10px 16px rgba(0, 0, 0, 0.2);
  }
  .chartjs-alert-tooltip-header {
    font-family: Lato;
    font-size: 13px;
    font-weight: 700;
    line-height: 16px;
    letter-spacing: 0.5px;
    text-align: left;
  }
  .chartjs-alert-tooltip-item {
    font-family: Lato;
    font-size: 13px;
    font-weight: 400;
    line-height: 16px;
    letter-spacing: 0.5px;
    text-align: left;
  }
</style>
